export default __webpack_public_path__ + "static/media/icon_lock_green.528a1ff6.svg";